<template>
  <div class="research_group_container" v-if="researchGroupCharacter === 'leader'">
<!--    <div class="hd research-background-color">-->
<!--      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>-->
<!--      <span class="header_title">成员管理</span>-->
<!--    </div>-->
    <div class="box">
      <div class="tabs-box">
             <div class="at-tabs__header">
                     <div @click="()=>{ this.tabType = 1}" :class="['at-tabs__item', tabType === 1 && 'at-tabs__item--active']">
                       课题组成员
                     </div>
               <div @click="()=>{ this.tabType = 2}" :class="['at-tabs__item', tabType === 2 && 'at-tabs__item--active']">
                 申请列表
               </div>
             </div>
      </div>
      <div v-if="tabType === 1">
        <div class="main">
          <div class="outer_3">
            <router-link :to="{name: 'ResearchMemberDetail', query: {memberIndex: index}}" class="outer_attr" v-for="(member, index) in memberList" :key="index">
              <div class="group">
                <div class="attr_name">{{member.memberName}}</div>
                <div class="block">
                  <span class="approve_none" v-if="member.approveType === approveTypeNone">{{researchGroupApproveTypeDictionary[member.approveType]}}</span>
                  <span class="approve_required" v-if="member.approveType === approveTypeAll">{{researchGroupApproveTypeDictionary[member.approveType]}}</span>
                  <span class="approve_required" v-if="member.approveType === approveTypeThreshold">{{researchGroupApproveTypeDictionary[member.approveType]}} </span>
                  <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
                </div>
              </div>
              <div class="container"><div class="empty" /></div>
            </router-link>
          </div>
        </div>
        <div class="ft research-background-color" @click="addMember">
          <span class="word">+</span> <span class="addMember">添加成员</span>
        </div>
      </div>
      <div v-if="tabType === 2 && approvalMemberList.length > 0">
        <div class="main">
          <div class="outer_3">
            <div @click="goDetailOrApproval(member, index)" class="outer_attr" v-for="(member, index) in approvalMemberList" :key="index">
              <div class="group">
                <div class="attr_name">{{member.memberName}}</div>
                <div class="block">
                  <span class="approve_required">{{member.status === 0 ? '待添加': '已添加'}} </span>
                  <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
                </div>
              </div>
              <div class="container"><div class="empty" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from 'vuex'
import EMKT from '../../../../emkt'
import wx from 'wx'
import $ from 'jquery'
export default {
  data () {
    return {
      researchGroupApproveTypeDictionary: EMKT.researchGroupApproveTypeDictionary,
      memberIndex: 1,
      approveTypeThreshold: EMKT.CONSTANT_APPROVETYPE_THRESHOLD,
      approveTypeNone: EMKT.CONSTANT_APPROVETYPE_NONE,
      approveTypeAll: EMKT.CONSTANT_APPROVETYPE_ALL,
      isWapp: EMKT.isWapp,
      tabType: 1,
      approvalMemberList: []
    }
  },
  mounted () {
    let _this = this
    _this.$weui.loading('数据加载中...')
    _this.gcapi('getAllRequestLogByResearchGroupNo', _this.displayChosenResearchGroup.researchGroupNo).then(res => {
      _this.$weui.loading().hide()
      _this.approvalMemberList = res.data.result.map(item => ({...item, createDT: item.createDT || EMKT.FormatterTime(new Date())}))
      if (_this.approvalMemberList.findIndex(item => item.status === 0) !== -1) {
        _this.tabType = 2
      }
    })
  },
  computed: {
    ...mapState([
      'researchGroupMemberMap'
    ]),
    ...mapGetters([
      'displayChosenResearchGroup', 'researchGroupCharacter'
    ]),
    memberList () {
      if (!this.displayChosenResearchGroup || JSON.stringify(this.displayChosenResearchGroup) === '{}') return
      if (!this.researchGroupMemberMap || JSON.stringify(this.researchGroupMemberMap) === '{}') return
      const researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
      return this.researchGroupMemberMap[researchGroupNo]
    }
  },
  methods: {
    ...mapMutations(['UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET']),
    goBack () {
      this.$router.push({name: 'ResearchGroupHome'})
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    addMember () {
      $.toast('EMKT.isWapp', EMKT.isWapp)
      if (EMKT.isWapp) {
        const { researchGroupNo, researchGroupName } = this.displayChosenResearchGroup
        wx.miniProgram.navigateTo({
          url: `/pages/researchGroupMember/share?researchGroupNo=${researchGroupNo}&researchGroupName=${researchGroupName}`
        })
      } else {
        this.$router.push({name: 'AddResearchMember'})
      }
    },
    goDetailOrApproval (member, index) {
      if (member.status === 0) {
        this.UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET(member)
        this.$router.push({name: 'ResearchMemberDetail', query: {memberIndex: index, type: EMKT.RESEARCH_MEMBER_OP.approval}})
      } else {
        let index1 = this.memberList.findIndex(item => item.memberNo === member.memberNo)
        if (index1 === -1) {
          $.toast('该成员已经不存在！')
          return
        }
        this.$router.push({name: 'ResearchMemberDetail', query: {memberIndex: index1}})
      }
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:scroll;
  overflow-x:hidden;
  /*-webkit-overflow-scrolling:touch;*/
  height:100%;
  width: 100%;
}

.box {
  /*display: flex;*/
  /*position: absolute;*/
  /*!*align-items: center;*!*/
  /*!*flex-direction: column;*!*/
  background-color: #efeef3;
  /*width: 100vw;*/
  /*height: calc(100vh - 14vw);*/
  /*top: 14.93vw;*/
  /*overflow: auto;*/
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}
.main {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 10px 0 20px 0;
  width: 99.73vw;
}

.outer_3 {
  /*display: flex;*/
  /*align-items: flex-start;*/
  /*flex-direction: column;*/
  /*justify-content: center;*/
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 95vw;
  padding: 2vw 0;
}

.outer_attr {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 95vw;
  height:12.8vw;
  /*flex-shrink: 0;*/
}
.outer_3 .outer_attr:last-child .empty{
  width: 82vw;
  height: 0.53vw;
  border: 0;
}

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 82vw;
  height: 0.53vw;
}

.group {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 3.47vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 95vw;
}

.attr_name {
  opacity: 1;
  width: 7.47vw;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 500;
}

.approve_none {
  opacity: 1;
  /* height: 5.33vw; */
  line-height: 5.33vw;
  white-space: nowrap;
  color: #60d837;
  font-size: 3.73vw;
  font-weight: 400;
}

.approve_required {
  opacity: 1;
  line-height: 5.33vw;
  white-space: pre;
  color: #ff9400;
  font-size: 3.73vw;
  font-weight: 400;
}
.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 4vw;
  width: 95vw;
}

.block {
  display: flex;
  align-items: center;
  flex-direction: row;
  /* width: 26.4vw; */
  height: 5.33vw;
}

.liveiconput {
  margin-left: 2vw;
  width: 4.5vw;
  height: 4.5vw;
}

.ft {
  display: flex;
  align-items: center;
  flex-direction: row;
  /* margin-top: 6.67vw; */
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  width: 95vw;
  height: 12vw;
  margin: 0 auto;
  margin-bottom: 10vw;
}

.word {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-end;
  opacity: 1;
  width: 39.47vw;
  height: 7.47vw;
  text-align: center;
  line-height: 7.47vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 5.33vw;
  font-weight: 400;
}

.addMember {
  opacity: 1;
  margin-top: 1.07vw;
  max-width: 47.2vw;
  height: 5.33vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}
.tabs-box .at-tabs__header {
  background-color: #5878fa;
  border: 1px solid #5878fa;
  border-radius: 25px;
  text-align: center;
}
.at-tabs__header {
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  background-color: #FFF;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: -moz-scrollbars-none;
}
.at-tabs__item--active {
  background-color: #fff;
  border-radius: 25px;
  color: #5878fa !important;
  margin: 3px;
}
.tabs-box .at-tabs__item {
  color: #fff;
  padding: 3px;
  margin-top: 3px;
}
.at-tabs__item--active {
  color: #6190E8;
}
.at-tabs__item {
  position: relative;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 12px 12px;
  color: #333;
  font-size: 14px;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// ResearchMemberManagement.vue?f19e4a44